<template>
  <div class="card">
    <div class="content">
      <div>
        <div style="padding-top:20px;">
          <slot name="video-link-thumb"></slot>
        </div>
        </div>
      </div>
      <div style="padding:0px 20px 20px 20px; height: 200px;">
        <hr/>
        <slot name="title"></slot>
        <hr/>
        <button class="btn btn-default btn-fill btn-wd" @click="confirmReviewRemove()">Remove</button>
      </div>
    </div>
  
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    name: 'review-card',
    props: ['ReviewId'],
    methods: {
      confirmReviewRemove () {
        swal.fire({
          title: 'Are you sure?',
          text: `Removing a review is permanent!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, remove it!',
          buttonsStyling: false
        }).then(function () {
          swal.fire({
            title: 'Removed!',
            text: 'The review was successfully removed.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
        })
      }
    }
  }

</script>
<style>
  
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/ReviewCard.vue